var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1862 3.52027C9.85137 3.37071 7.86563 5.07446 7.68986 7.24772C7.51489 9.41117 9.19225 11.3369 11.5194 11.486C13.8542 11.6356 15.84 9.93181 16.0157 7.75854C16.0162 7.75261 16.0167 7.74668 16.0171 7.74075C15.8432 7.7653 15.6645 7.77259 15.4831 7.76097C14.1054 7.67272 13.0138 6.50739 13.128 5.09513C13.1659 4.62658 13.3317 4.20245 13.5861 3.84874C13.1571 3.66701 12.6863 3.55231 12.1862 3.52027ZM14.3898 3.12303C13.7537 2.78483 13.0313 2.5725 12.2556 2.52282C9.40572 2.34026 6.91509 4.42204 6.69263 7.17259C6.47017 9.92315 8.60011 12.3009 11.45 12.4835C14.2999 12.666 16.7905 10.5842 17.013 7.83367C17.0255 7.67899 17.0305 7.52548 17.0285 7.37348C17.023 6.97378 16.9681 6.58446 16.869 6.21144C16.6413 6.47852 16.3219 6.66823 15.9622 6.73771C15.8302 6.76319 15.6928 6.7725 15.5525 6.76351C14.6975 6.70875 14.0585 5.99542 14.1253 5.17026C14.1503 4.86036 14.2714 4.57877 14.4581 4.35082C14.6843 4.07457 15.0069 3.87712 15.372 3.8036C15.0755 3.54154 14.7462 3.31253 14.3898 3.12303Z",
    fill: "#2A2D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.5C23 7.05149 22.7455 6.75695 22.2365 6.16786C20.3744 4.01267 16.2673 0 11.5 0C6.73266 0 2.62556 4.01267 0.763465 6.16786C0.254488 6.75695 0 7.05149 0 7.5C0 7.94851 0.254488 8.24305 0.763464 8.83214C2.62555 10.9873 6.73266 15 11.5 15C16.2673 15 20.3744 10.9873 22.2365 8.83214C22.7455 8.24305 23 7.94851 23 7.5ZM11.1456 13.75C15.735 13.75 20.98 9.57107 20.98 7.5C20.98 5.42893 15.735 1.25 11.5 1.25C7.265 1.25 2.62249 5.42893 2.62249 7.5C2.62249 9.57107 7.21186 13.75 11.1456 13.75Z",
    fill: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSee);
export default __webpack_public_path__ + "static/media/see.2333e3e00cbe1549b806ad3cb78993fc.svg";
export { ForwardRef as ReactComponent };